import { __ } from '@wordpress/i18n';
import {
	PanelBody,
	TextControl,
	RangeControl,
	CheckboxControl,
} from '@wordpress/components';
import { Fragment, useState } from '@wordpress/element';
import { ModalPromo } from '../../../admin/components/modal-promo.js';

const OpenTriggers = ( props ) => {
	const { attributes, setAttributes } = props;
	const { triggers, settings } = attributes;

	const [ promo, showPromo ] = useState(false);

	const updateTrigger = ( triggerName, triggerType, val ) => {
		setAttributes( {
			settings: {
				...settings,
				[ triggerName ]: { [ triggerType ]: val },
			},
		} );
	};

	const handleChangeOpenTriggers = ( trigger, val ) => {
		let filteredArray = [];
		if ( val ) {
			filteredArray = [ ...triggers, trigger ];
		} else {
			filteredArray = triggers.filter( ( item ) => item !== trigger );
		}
		setAttributes( {
			triggers: filteredArray,
		} );
	};

	const options = [
		{
			label: __( 'On Load', 'popper' ),
			value: 'load',
			help: __( 'Shows on page load.', 'popper' ),
		},
		{ label: __( 'Timer', 'popper' ), value: 'timer' },
		{
			label: __( 'On Anchor Click', 'popper' ),
			value: 'anchor',
		},
		{
			label: __( 'On Hover', 'popper' ),
			value: 'hover',
		},
		{
			label: __( 'On AdBlock Detect', 'popper' ),
			value: 'adBlock',
			pro: true,
		},
		{
			label: __( 'On Target Visibility', 'popper' ),
			value: 'target',
			pro: true,
		},
		{ label: __( 'On Scroll', 'popper' ), value: 'scroll' },
		{
			label: __( 'On Exit Intent', 'popper' ),
			value: 'exit',
			help: __(
				'Shows the popup when the user moves the mouse outside of the top of the window.',
				'popper'
			),
			pro: true,
		},
	];

	return (
		<PanelBody
			initialOpen={ true }
			title={ __( 'Open Trigger', 'popper' ) }
		>
			{ options.map( ( o, i ) => {
				return (
					<Fragment key={ i }>
						<CheckboxControl
							label={ o.label + ( o.pro && ! popper.pro ? ' (PRO)' : '' ) }
							checked={ triggers?.includes( o.value ) }
							onChange={ ( val ) =>
								o.pro && ! popper.pro ? showPromo( true ) : handleChangeOpenTriggers( o.value, val )
							}
							help={ o.help || '' }
							__nextHasNoMarginBottom
						/>
						{ 'anchor' === o.value &&
							triggers?.includes( 'anchor' ) && (
								<TextControl
									value={ settings.anchor?.target || '' }
									label={ __( 'Anchor', 'popper' ) }
									help={ __(
										'You can add anchors to button blocks. Using the same anchor here will open the popup when users click the respective button.',
										'popper'
									) }
									onChange={ ( val ) =>
										updateTrigger( 'anchor', 'target', val )
									}
									__nextHasNoMarginBottom
								/>
							) }
						{ 'hover' === o.value &&
							triggers?.includes( 'hover' ) && (
								<TextControl
									value={ settings.hover?.target || '' }
									label={ __( 'Anchor', 'popper' ) }
									help={ __(
										'You can add anchors to HTML elements. Using the same anchor here will open the popup when users hover the element.',
										'popper'
									) }
									onChange={ ( val ) =>
										updateTrigger( 'hover', 'target', val )
									}
									__nextHasNoMarginBottom
								/>
							) }
						{ 'adBlock' === o.value &&
							triggers?.includes( 'adBlock' ) && (
								<RangeControl
									label={ __(
										'Scroll Distance in Percentage',
										'popper'
									) }
									help={ __(
										'Show the popup when this percentage of the page has been scrolled.',
										'popper'
									) }
									beforeIcon="image-flip-vertical"
									value={
										settings.adBlock?.scrollPercent || ''
									}
									onChange={ ( val ) =>
										updateTrigger(
											'adBlock',
											'scrollPercent',
											val
										)
									}
									min={ 20 }
									max={ 100 }
									__nextHasNoMarginBottom
								/>
							) }
						{ 'target' === o.value &&
							triggers?.includes( 'target' ) && (
								<TextControl
									value={ settings.anchor?.target || '' }
									label={ __( 'Target', 'popper' ) }
									help={ __(
										'Show a popup when element with this anchor enter in viewport.',
										'popper'
									) }
									onChange={ ( val ) =>
										updateTrigger( 'anchor', 'target', val )
									}
									__nextHasNoMarginBottom
								/>
							) }
						{ 'scroll' === o.value &&
							triggers?.includes( 'scroll' ) && (
								<RangeControl
									label={ __(
										'Scroll Distance in Percent',
										'popper'
									) }
									help={ __(
										'Show the popup when this percentage of the page has been scrolled.'
									) }
									beforeIcon="image-flip-vertical"
									value={
										settings.scroll?.scrollPercent || ''
									}
									onChange={ ( val ) =>
										updateTrigger(
											'scroll',
											'scrollPercent',
											val
										)
									}
									min={ 20 }
									max={ 100 }
									__nextHasNoMarginBottom
								/>
							) }
						{ 'timer' === o.value &&
							triggers?.includes( 'timer' ) && (
								<RangeControl
									label={ __(
										'Wait Time in Seconds',
										'popper'
									) }
									help={ __(
										'How much time to wait before showing the popup.'
									) }
									beforeIcon="clock"
									value={ settings.timer?.time || '' }
									onChange={ ( val ) =>
										updateTrigger( 'timer', 'time', val )
									}
									min={ 0 }
									max={ 100 }
									__nextHasNoMarginBottom
								/>
							) }
					</Fragment>
				);
			} ) }
			{
				promo && (
					<ModalPromo onRequestClose={ () => showPromo(false) } />
				)
			}
		</PanelBody>
	);
};

export default OpenTriggers;
